@import '../config/_helpers';
.action-buttons{
    display: flex;
    align-items: center;
    gap: 30px;
    justify-content: flex-end;
    align-items: flex-end;
    .review-rating{
        padding: 5px 10px;
        border-radius: 10px;        
        color: var(--contrast-color-dark-2);
        background: var(--contrast-color-light-6);

		user-select: none;
		span {
			font-size: 9px;
		}
	}
	.add-to-cart-button {
		flex: 1;
		background: var(--accent-color);
		color: black;
		border: none;
		padding: 10px 20px;
		font-weight: bold;
		margin-top: 0;
		&:hover {
			background: var(--accent-color-dark-2);
		}
	}
	.wishlist-button {
		background: var(--tertiary-color-light-6);
		color: var(--tertiary-color);
	}
	.wishlist-button-container {
		height: 100%;
		position: relative;
		.wishlist-icon {
			height: 100%;
			display: flex;
			align-items: center;
			padding: 5px 10px;
			border-radius: 10px;
			background: var(--tertiary-color-light-6);
			color: var(--tertiary-color);

			transition: 0.4s all ease-in-out;
			cursor: pointer;
			&:hover {
				background: var(--tertiary-color-light-5);
			}

			&:after,
			&:before {
				position: absolute;
				content: "";
				display: block;
				width: 140%;
				height: 100%;
				left: -20%;
				z-index: 0;
				transition: all ease-in-out 0.5s;
				background-repeat: no-repeat;
			}

			&:before {
				display: none;
				top: -75%;
				background-image:
					radial-gradient(circle, var(--tertiary-color) 20%, transparent 20%),
					radial-gradient(circle, transparent 20%, var(--tertiary-color) 20%, transparent 30%),
					radial-gradient(circle, var(--tertiary-color) 20%, transparent 20%),
					radial-gradient(circle, var(--tertiary-color) 20%, transparent 20%),
					radial-gradient(circle, transparent 10%, var(--tertiary-color) 15%, transparent 20%),
					radial-gradient(circle, var(--tertiary-color) 20%, transparent 20%),
					radial-gradient(circle, var(--tertiary-color) 20%, transparent 20%),
					radial-gradient(circle, var(--tertiary-color) 20%, transparent 20%),
					radial-gradient(circle, var(--tertiary-color) 20%, transparent 20%);
				background-size:
					10% 10%,
					20% 20%,
					15% 15%,
					20% 20%,
					18% 18%,
					10% 10%,
					15% 15%,
					10% 10%,
					18% 18%;
			}

			&:after {
				display: none;
				bottom: -75%;
				background-image:
					radial-gradient(circle, var(--tertiary-color) 20%, transparent 20%),
					radial-gradient(circle, var(--tertiary-color) 20%, transparent 20%),
					radial-gradient(circle, transparent 10%, var(--tertiary-color) 15%, transparent 20%),
					radial-gradient(circle, var(--tertiary-color) 20%, transparent 20%),
					radial-gradient(circle, var(--tertiary-color) 20%, transparent 20%),
					radial-gradient(circle, var(--tertiary-color) 20%, transparent 20%),
					radial-gradient(circle, var(--tertiary-color) 20%, transparent 20%);
				background-size:
					15% 15%,
					20% 20%,
					18% 18%,
					20% 20%,
					15% 15%,
					10% 10%,
					20% 20%;
			}

			&.wishlisted {
				&:before {
					display: block;
					animation: topBubbles ease-in-out 0.75s forwards;
				}
				&:after {
					display: block;
					animation: bottomBubbles ease-in-out 0.75s forwards;
				}
			}
		}
	}

	&.left {
		justify-content: flex-start;
	}
	&.right {
		justify-content: flex-end;
	}
}

@keyframes topBubbles {
	0% {
		background-position:
			5% 90%,
			10% 90%,
			10% 90%,
			15% 90%,
			25% 90%,
			25% 90%,
			40% 90%,
			55% 90%,
			70% 90%;
	}
	50% {
		background-position:
			0% 80%,
			0% 20%,
			10% 40%,
			20% 0%,
			30% 30%,
			22% 50%,
			50% 50%,
			65% 20%,
			90% 30%;
	}
	100% {
		background-position:
			0% 70%,
			0% 10%,
			10% 30%,
			20% -10%,
			30% 20%,
			22% 40%,
			50% 40%,
			65% 10%,
			90% 20%;
		background-size:
			0% 0%,
			0% 0%,
			0% 0%,
			0% 0%,
			0% 0%,
			0% 0%;
	}
}
@keyframes bottomBubbles {
	0% {
		background-position:
			10% -10%,
			30% 10%,
			55% -10%,
			70% -10%,
			85% -10%,
			70% -10%,
			70% 0%;
	}
	50% {
		background-position:
			0% 80%,
			20% 80%,
			45% 60%,
			60% 100%,
			75% 70%,
			95% 60%,
			105% 0%;
	}
	100% {
		background-position:
			0% 90%,
			20% 90%,
			45% 70%,
			60% 110%,
			75% 80%,
			95% 70%,
			110% 10%;
		background-size:
			0% 0%,
			0% 0%,
			0% 0%,
			0% 0%,
			0% 0%,
			0% 0%;
	}
}
